<template>
  <div class="home" v-if="!isTest">
    <div class="home__cover"></div>
    <div class="home__buttons">
      <button class="main-button home__button" @click="start">開始測驗</button>
      <!-- <button class="main-button home__button" @click="logout">登出</button> -->
    </div>
  </div>
  <InvestmentTest :resultDefault="result" @restart="restart" v-else />
</template>

<script>
import InvestmentTest from '@/components/InvestmentTest';
import api from '@/services/api';
import { addELK } from '@/plugins/elk';

export default {
  name: 'HomeView',
  data() {
    return {
      isTest: false,
      result: [],
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
  },
  async created() {
    const tokenAt = new URLSearchParams(window.location.search).get('at');
    if (tokenAt) {
      this.$store.dispatch('updateToken', {
        at: tokenAt,
      });
    }
    this.getUserInfo();
  },
  methods: {
    start() {
      addELK('Start_Test', {
        Parameter: '開始測驗',
      });
      // 取得測驗紀錄
      const dataString = window.localStorage.blueTest;
      if (dataString) {
        const data = JSON.parse(dataString).find(
          (item) => item.user === this.userInfo.nickname,
        );
        if (data) {
          this.result = data.result;
        }
      }
      if (
        window.history.state === null
        || !window.history.state.key
        || window.history.state.key !== 'blueTest start'
      ) {
        window.history.pushState(
          { key: 'blueTest start' },
          'start test',
          '#start',
        );
      }
      this.isTest = true;
    },
    restart() {
      this.result = [];
      this.isTest = false;
    },
    // 檢查使用者client的token
    // async checkUserToken() {
    // 去拿OIDC的user資訊，如果無資訊，轉導至登入頁
    // this.getUserInfo();
    // .then(() => {
    //   // 取得測驗紀錄
    //   const dataString = window.localStorage.blueTest;
    //   if (dataString) {
    //     const data = JSON.parse(dataString).find(
    //       (item) => item.user === this.userInfo.nickname,
    //     );
    //     if (data) {
    //       this.start();
    //       this.result = data.result;
    //     }
    //   }
    // });
    // },
    // 檢查使用者client的token並取得使用者資訊
    async getUserInfo() {
      return new Promise((resovle, reject) => {
        api.getMemberInfo().then(
          (res) => {
            const { data } = res;
            if (data) {
              this.$store.dispatch('setUserInfo', {
                nickname: data.nickname,
              });
              resovle(data.nickname);
            } else {
              this.$store.dispatch('loginRedirectUnityPage');
              reject();
            }
          },
          () => {
            this.$store.dispatch('loginRedirectUnityPage');
            reject();
          },
        );
      });
    },
    logout() {
      this.$store.dispatch('logoutRedirectUnityPage');
    },
  },
  components: {
    InvestmentTest,
  },
};
</script>

<style scoped>
.home__cover {
  width: 100%;
  height: calc(100vh - 92px);
  height: calc(var(--vh, 1vh) * 100  - 92px);
  background-image: url("../assets/images/cover.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.home__buttons {
  background-color: #f8f8f8;
  width: 100%;
  display: flex;
}
.home__button {
  flex-grow: 1;
  margin: 24px;
  line-height: 44px;
  font-size: 20px;
}
</style>
